import React, { useContext } from 'react';
import { Context as CountriesContext } from '../context/CountriesContext';
import { Context as StatContext } from '../context/StatContext';
import { Map as LeafletMap, TileLayer } from 'react-leaflet';
import { buildMap, findCountry, isGlobal } from '../utils';
import '../styles/Map.css';
import 'leaflet/dist/leaflet.css';

const DEFAULT_ZOOM = 2;
const COUNTRY_ZOOM = 4;

function Map() {
  const {
    state: { countries, selectedCountry }
  } = useContext(CountriesContext);

  const { statType } = useContext(StatContext);

  const country = findCountry(countries, selectedCountry);

  const { lat, long } = country.countryInfo;
  const coords = { lat, lng: long };
  const zoom = !isGlobal(country) ? COUNTRY_ZOOM : DEFAULT_ZOOM;

  return (
    <div id="map">
      <LeafletMap center={coords} zoom={zoom}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        {buildMap(countries, statType)}
      </LeafletMap>
    </div>
  );
}

export default Map;
